<template>
  <el-card>
    <p class="tip">角色由系统预置；平台账号的「角色」在用户管理 · 平台账号中分配。</p>
    <el-table :data="rows" border stripe v-loading="loading">
      <el-table-column prop="code" label="编码" width="120" />
      <el-table-column prop="name" label="名称" width="160" />
      <el-table-column label="创建时间" min-width="170">
        <template slot-scope="s">{{ s.row.createdAt | formatDateTime }}</template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import http from '../api/http';

export default {
  name: 'RolesView',
  data() {
    return { loading: false, rows: [] };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await http.get('/admin/roles');
        this.rows = data.data || data || [];
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.tip {
  color: #909399;
  font-size: 13px;
  margin-bottom: 12px;
}
</style>
